<template>
	<div class="themes">

		<ListWithTitle :data="quiz.themes">
			<template #title>
				{{ quiz.title }}
			</template>
			<template #list="{data}">
				<ThemeItem :data="data" />
			</template>
		</ListWithTitle>

	</div>
</template>

<script>
	import {mapState, mapActions} from 'vuex'
	import ListWithTitle from '~/components/General/ListWithTitle';
	import ThemeItem from '../Themes/ThemeItem.vue';

	export default {
		name: 'Quiz',
		components: {
			ListWithTitle,
			ThemeItem
		},
		computed: {
			...mapState ('learn', ['quiz'])
		},
		created() {
			this.getThemesAll();
		},
		methods: {
			...mapActions ('learn', ['getThemesAll'])
		}
	}
</script>

<style lang="scss" scoped>
	.list {
		margin-bottom: 0;
	}
</style>

<style lang="scss">

	.themes {

		$root: &;

		&__more, &__tags {
			@include h-gap;
		}

		&__more {
			color: $primary;
			text-decoration: underline;
			font-size: $font-size-normal;
		}

		&__tags {
			margin-top: $big-gutter;
			margin-bottom: $half-gutter;
		}

	}

</style>
